/**
 * Detección de móvil y tiendas de la app.
 *
 * Vivía dentro de `pages/DownloadRedirect.jsx`. Se saca aquí porque la barra
 * superior de la landing necesita lo mismo: enseñarle a cada visitante el botón
 * de SU tienda. Tener las dos URLs en dos sitios era pedir que un día se
 * cambiara una y la otra no.
 */

export const APP_STORE_URL = "https://apps.apple.com/app/id6756500478";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.facundosolis.wayo";
export const DOWNLOAD_URL = "https://wayoai.app/download";

export function isIOS(userAgent) {
  const hasIOSAgent = /iPad|iPhone|iPod/i.test(userAgent);
  // Un iPad con "Solicitar sitio para escritorio" se presenta como Macintosh.
  // Lo unico que lo delata es que acepta varios puntos de contacto.
  const isIPadOSDesktopMode =
    /Macintosh/i.test(userAgent) &&
    typeof navigator !== "undefined" &&
    navigator.maxTouchPoints > 1;

  return hasIOSAgent || isIPadOSDesktopMode;
}

export function isAndroid(userAgent) {
  return /Android/i.test(userAgent);
}

export function getMobileStoreUrl(userAgent) {
  if (isAndroid(userAgent)) return GOOGLE_PLAY_URL;
  if (isIOS(userAgent)) return APP_STORE_URL;
  return DOWNLOAD_URL;
}

/**
 * Lo que necesita quien solo quiere pintar un boton: a donde lleva y como se
 * llama la tienda. En escritorio devuelve `movil: false` y la pagina /download,
 * que ya ensena los dos botones.
 *
 * Se lee del `navigator` en el momento de llamarla, asi que hay que invocarla
 * dentro del componente (o de un efecto), nunca en el ambito del modulo: el
 * prerender la ejecuta en Node, donde no hay `navigator`.
 */
export function tiendaDelVisitante() {
  if (typeof navigator === "undefined") {
    return { movil: false, url: DOWNLOAD_URL, nombre: null };
  }

  const ua = navigator.userAgent || navigator.vendor || window.opera || "";

  if (isAndroid(ua)) return { movil: true, url: GOOGLE_PLAY_URL, nombre: "Google Play" };
  if (isIOS(ua)) return { movil: true, url: APP_STORE_URL, nombre: "App Store" };

  return { movil: false, url: DOWNLOAD_URL, nombre: null };
}
